import React, { useState } from "react";
import "../components/AfiliacionPublica.css";
import {
  Box,
  Step,
  StepLabel,
  Stepper,
  Typography,
  Paper,
  Container
} from "@mui/material";
import { useMediaQuery } from "@mui/material";
import Logo from "../assets/Logo.png";
import PasoValidacion from "./afiliacion/PasoValidacion";
import PasoDatos from "./afiliacion/PasoDatos";
import PasoAhorros from "./afiliacion/PasoAhorros";
import PasoBeneficiarios from "./afiliacion/PasoBeneficiarios";
import PasoReferencias from "./afiliacion/PasoReferencias";
import PasoResumen from "./afiliacion/PasoResumen";
import PageTitle from "../components/PageTitle";

const steps = [
  "Validación",
  "Datos personales",
  "Ahorros",
  "Beneficiarios",
  "Referencias",
  "Resumen"
];

/* ======================================================
   🔹 ESTADO INICIAL DEL FORMULARIO
====================================================== */
const initialFormData = {
  // Validación
  numeroDocumento: "",

  // Datos personales
  nombres: "",
  fechaNacimiento: "",
  lugarNacimiento: "",
  genero: "",
  tipoIdentidad: "",
  fechaExpedicion: "",
  ciudadExpedicion: "",
  direccion: "",
  barrio: "",
  municipio: "",
  departamento: "",
  telefonoFijo: "",
  celular: "",
  correoPersonal: "",
  estrato: "2",
  cabezaFamilia: "No",
  personasCargo: "0",
  nivelEstudios: "Bachillerato",
  tituloProfesional: "Bachiller",
  estadoCivil: "",
  tipoVivienda: "Arrendada",
  actividadEconomica: "Empleado",
  codigoCIIU: "010",
  grupoEtnico: "Ninguno",
  empresaContratante: "ManpowerGroup",

  // Ahorros
  ahorroObligatorio: "",
  aLaVista: "",
  navideno: "",
  vehiculo: "",
  salario: "",

  // Dinámicos
  beneficiarios: [],
  referencias: [],

  // Declaraciones
  declaraciones: false,

  // Control
  affiliationId: null,
  radicado: null
};

export default function AfiliacionPublica() {

  const [activeStep, setActiveStep] = useState(0);
  const [formData, setFormData] = useState(initialFormData);

  /* ======================================================
     🔹 HELPERS DE FLUJO
  ====================================================== */
  const updateData = (data) => {
    setFormData((prev) => ({ ...prev, ...data }));
  };

  const next = () => setActiveStep((prev) => prev + 1);
  const back = () => setActiveStep((prev) => prev - 1);

  /* ======================================================
     🔹 RESET TOTAL (NUEVA AFILIACIÓN)
  ====================================================== */
  const resetAfiliacion = () => {
    setFormData(initialFormData); // limpia TODO
    setActiveStep(0);             // vuelve a VALIDACIÓN
  };

  /* ======================================================
     🔹 RENDER DE PASOS
  ====================================================== */
  const renderStep = () => {
    switch (activeStep) {
      case 0:
        return (
          <PasoValidacion
            data={formData}
            update={updateData}
            next={next}
          />
        );

      case 1:
        return (
          <PasoDatos
            data={formData}
            update={updateData}
            next={next}
            back={back}
          />
        );

      case 2:
        return (
          <PasoAhorros
            data={formData}
            update={updateData}
            next={next}
            back={back}
          />
        );

      case 3:
        return (
          <PasoBeneficiarios
            data={formData}
            update={updateData}
            next={next}
            back={back}
          />
        );

      case 4:
        return (
          <PasoReferencias
            data={formData}
            update={updateData}
            next={next}
            back={back}
          />
        );

      case 5:
        return (
          <PasoResumen
            data={formData}
            update={updateData}
            back={back}
            reset={resetAfiliacion}   // 👈 CLAVE
          />
        );

      default:
        return "Paso no encontrado";
    }
  };

  const isMobile = useMediaQuery("(max-width:600px)");


  /* ======================================================
     🔹 UI
  ====================================================== */
  return (

    <>

    <PageTitle title="Afiliación" />

    <Container className="afiliacion-wrapper">
      <Paper elevation={3} className="afiliacion-card">

        <Box display="flex" justifyContent="center" mb={0}>
          <img
            src={Logo}
            alt="Logo Fondo"
            style={{ height: 75, objectFit: "contain" }}
          />
        </Box>

        <Typography variant="h5" fontWeight={700} textAlign="center">
          Solicitud de Afiliación
        </Typography>

        <Typography variant="h6" fontWeight={300} textAlign="center" mb={3}>
          Fondo de Empleados de ManpowerGroup
        </Typography>

        <Stepper
          activeStep={activeStep}
          alternativeLabel={!isMobile}
          orientation="horizontal"
          className="afiliacion-stepper"
          sx={{ mb: 4 }}
        >

          {steps.map((label) => (
            <Step key={label}>
              <StepLabel>{label}</StepLabel>
            </Step>
          ))}
        </Stepper>

        <Box>{renderStep()}</Box>

      </Paper>
    </Container>

    </>
    
  );
}
